export interface DmpHlSetDmpAccessModeParams {
  i_accessMode: DmpHlAccessModeEnum;
  s_reason?: string;
}

export enum DmpHlAccessModeEnum {
  'Accès normal' = 1,
  'Accès "Bris de glace"' = 2,
  'Accès "centre 15"' = 3,
}
